import { PresenceLatest } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useCameraOccupancyLatest(camId: string, enabled = true) {
  const url = `/v2/orm/presence/cameras/${camId}/occupancy/latest`;
  const request = new Request(url);

  return useAuthenticatedRequest<PresenceLatest>(request, {
    queryKey: ['presence-latest', camId],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    refetchInterval: 30 * 1000,
    enabled,
  });
}

export default useCameraOccupancyLatest;
